/*
 * Ryan O'Dowd
 * 2024-08-19
 * © Copyright 2024 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = ({globalScale, fonts, colors}) => {
  return {
    titleAndAction: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    disabled: {
      color: colors.gray,
      opacity: 0.5,
      cursor: 'not-allowed',
      // @TODO: disable mouse events
    },
    joinCodeContainer: {
      marginTop: globalScale * 16,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    joinCodeWrapper: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
    },
    joinCode: { // @TODO: abstract with Classroom/styles.web.js for student table
      padding: 6,
      backgroundColor: colors.accent,
      color: colors.primaryExtraDark,
      borderRadius: 6,
      fontSize: globalScale * 14,
      fontFamily: fonts.secondaryBold,
    },
    code: {
      padding: 2,
      backgroundColor: colors.primaryExtraLight,
      fontSize: 12,
      borderRadius: 6,
    },
    emails: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      // @TODO: minHeight: 100,
    },
    newEmail: {
      backgroundColor: colors.accent,
      color: colors.primaryExtraDark,
    },
    alreadyInvitedEmail: {
      backgroundColor: colors.complete,
      color: colors.primaryExtraDark,
    },
    alreadyAcceptedEmail: {
      backgroundColor: colors.alert,
      color: colors.white,
    },
    legend: {
      paddingTop: 16,
      lineHeight: 2,
    },
    legendText: {
      padding: 6,
      borderRadius: 6,
      fontSize: 14,
      fontWeight: '600',
    },
  };
};

export default getStyles;
